import {
    MESSAGE_TEMPLATE_DELETE_OPEN_MODAL,
    MESSAGE_TEMPLATE_DELETE_REQUEST,
    MESSAGE_TEMPLATE_DELETE_RESULT,
} from 'Redux/actionTypes';

export const messageTemplateDeleteOpenModal = (open, messageTemplate) => ({
    type: MESSAGE_TEMPLATE_DELETE_OPEN_MODAL,
    payload: { open, messageTemplate }
})

export const messageTemplateDeleteRequest = (data) => ({
    type: MESSAGE_TEMPLATE_DELETE_REQUEST,
    payload: data
})

export const messageTemplateDeleteResult = (data) => ({
    type: MESSAGE_TEMPLATE_DELETE_RESULT,
    payload: data
})